import { render, staticRenderFns } from "./VehiclesGarage.vue?vue&type=template&id=1b54cbee&scoped=true&"
import script from "./VehiclesGarage.vue?vue&type=script&lang=ts&"
export * from "./VehiclesGarage.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesGarage.vue?vue&type=style&index=0&id=1b54cbee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54cbee",
  null
  
)

export default component.exports